<template>
  <div class="top_menu">
    <div class="nav-bar-main">
      <div class="logo_bjd"></div>
      <div class="nav-bar-list">
        <router-link
          class="bot_menu"
          target="blank"
          :to="{name: 'Home'}"
          active-class
         >官网首页</router-link>
        <!-- <router-link
          class="bot_menu"
          :to="{name: 'Exchange'}"
          target="blank"
          active-class="router-link-active"
        >奖品兑换</router-link> -->
        <router-link
          class="bot_menu"
          target="blank"
          to="/download"
          active-class="router-link-active"
        >下载中心</router-link>
        <router-link
          class="bot_menu"
          target="blank"
          :to="{name: 'news'}"
          active-class="router-link-active"
        >新闻公告</router-link>
        <router-link
          class="bot_menu"
          :to="{name: 'ServiceCenter'}"
          target="blank"
          active-class="router-link-active"
        >客服中心</router-link>
        <router-link
          target="blank"
          :to="{name: 'Wxpay'}"
          class="bot_menu"
        >充值中心</router-link>
      </div>
      <!--用户登录状态-->
      <div class="nav_login_box">
        <div class="userstate"  style="display:block" v-show="showUserState">
          <span class="username">你好！{{nickname}}</span>
          <a class="login_btn_box_btn nav_a_link" href="javascript:void(0);" @click="LogOut">退出</a>
        </div>
        <a v-show="!showUserState" class="login_btn_box_btn nav_a_link" href="javascript:void(0);"  @click="openLoginBox()">[登录]</a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { getToken, getUserInfo } from '@/libs/util'

export default {
  computed: {
    nickname () {
      const userInfo = getUserInfo()
      if (userInfo) {
        return userInfo.nickname
      }
    },
    showUserState () {
      if (getToken()) {
        return true
      }
      return false
    }
  },
  methods: {
    ...mapActions([
      'handleLogOut'
    ]),
    LogOut () {
      this.handleLogOut()
      location.reload()
    },
    openLoginBox () {
      this.$store.commit('showLoginBox', true)
      this.$store.commit('showBlackOver', 'block')
    }
  }
}
</script>

<style scoped>

/*导航栏*/
.top_menu {
  width: 100%;
  height: 75px;
  display: block;
  position: absolute;
  top: 0;
  float: left;
  z-index: 99;
  position: fixed;
  left: 0;
  background: rgba(32, 32, 32, 0.6);
}

.nav-bar-main {
  width: 1280px;
  height: 75px;
  color: #fff;
  font-size: 20px;
  text-align: center;
  margin: 0 auto;
}

.logo_bjd {
  width: 145px;
  height: 100%;
  display: block;
  float: left;
  background-image: url('~@/assets/image/logo_bjd.png');
  background-repeat: no-repeat;
  background-size: contain;
  margin-top: 7px;
}

.nav-bar-list {
  margin-left: 50px;
  width: 785px;
  float: left;
}

.bot_wk {
  width: 120px;
  display: block;
  float: left;
}
.bot_menu_xz {
  width: 131px;
  display: block;
  float: left;
  background-image: url('~@/assets/image/bot_menu_xz.png');
  background-repeat: no-repeat;
  background-size: contain;
  margin-left: 120px;
}

.bot_menu {
  width: 130px;
  height: 75px;
  display: block;
  color: #cccccc;
  float: left;
  padding-top: 26px;
}

.router-link-exact-active{
  background: #f3c259;
  color: #080808;
}

.router-link-active{
  background: #f3c259;
   color: #080808;
}

.top_menu_bg- > a {
  width: 131px;
  display: block;
  float: left;
  color: #fff;
  font-size: 22px;
  text-align: center;
  padding-top: 26px;
}

.bot_menu:hover {
  /* background: #f3c259; */
  color: #ffffff;
}

/*用户登录状态*/
.nav_login_box {
    width: 300px;
    float: left;
    line-height: 77px;
    display: block;
}
.userstate {
  width: 100%;
  height: 75px;
  color: #fff;
  font-size: 16px;
  text-align: center;
}

.login_btn_box_btn {
  color: #E6A23C;
  font-size: 20px;
  margin-right: 20px;
}

.username {
  width: 200px;
  display: block;
  float: left;
  color: #f3c258;
  text-align: right;
  margin-right: 20px;
  font-size: 20px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.nav_a_link:hover {
  color: #fff;
}

.p1 {
  width: 100%;
  height: 553px;
  display: block;
  float: left;
}
.p1_line01 {
  width: 100%;
  height: 28px;
  display: block;
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/components/NavBar.vue